import {
  METODOS_CIERRE,
  type AggregateLine,
  type BalanceByMethod,
  type MetodoCierre,
} from './types';

export function aggregateToBalance(lines: AggregateLine[]): BalanceByMethod {
  const b = {
    efectivo: 0,
    banco: 0,
    nequi: 0,
    daviplata: 0,
    tarjeta: 0,
    otro: 0,
  } satisfies BalanceByMethod;
  for (const l of lines) {
    const raw = String(l.cierre_metodo || 'otro').toLowerCase();
    const key: MetodoCierre = METODOS_CIERRE.includes(raw as MetodoCierre)
      ? (raw as MetodoCierre)
      : 'otro';
    const add = typeof l.total === 'string' ? parseInt(l.total, 10) : Number(l.total) || 0;
    b[key] += add;
  }
  return b;
}

export function computeSaldoFinal(
  inicial: BalanceByMethod,
  ingresos: BalanceByMethod,
  gastos: BalanceByMethod
): BalanceByMethod {
  const out = { ...inicial };
  for (const m of METODOS_CIERRE) {
    out[m] = inicial[m] + ingresos[m] - gastos[m];
  }
  return out;
}

export function totalBalance(b: BalanceByMethod): number {
  return METODOS_CIERRE.reduce((s, m) => s + b[m], 0);
}

export function formatCOP(amount: number): string {
  return (
    '$' +
    Math.round(amount).toLocaleString('es-CO', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    })
  );
}
